<template>

  <div>
    <div style="width: 100%;">
      <img src="./abuous01.png" alt="关于我们" style="width: 100%; height: auto;" loading="lazy">
    </div>

    <!--关于我们介绍-->
    <div class="wd100 pdtop" style="width: 1255px;margin: 0px auto;position: relative;z-index: 199;">
      <div class="container">
        <div class="about-us">
          <div>
            <img src="./us.jpeg" alt="关于我们" style="width: 482px;height: 330px">
            <div class="stats-container">
              <div class="stat-item">
                <div class="stat-div">
                  <h1>1800+</h1>
                  <p>年服务企业</p>
                </div>

                <div class="stat-div">
                  <h1>10000+</h1>
                  <p>知识产权申请</p>
                </div>
              </div>

              <div class="stat-item">
                <div class="stat-div">
                  <h1>500+</h1>
                  <p>累计辅导高新企业认定</p>
                </div>

                <div class="stat-div">
                  <h1>200+</h1>
                  <p>累计辅导专精特新企业</p>
                </div>
              </div>

            </div>
          </div>
          <div class="about-us-content">
            <h2 class="about-us-title">关于我们 About US</h2>
            <p class="about-us-description">
              恩施安贝森科技服务股份有限公司（以下简称“安贝森科服”）成立于2018年2月日，总部位于湖北省恩施土家族苗族自治州恩施市舞阳坝街道金龙大道中段企业服务中心1-3室，公司注册资本为500万(元)。公司拥有2个注册商标，21项专利，23项软件著作权。</p>
            <p class="about-us-description">
              安贝森科服是一家本土专业从事知识产权、科技项目服务平台。公司秉持“贴近客户、诚信服务、专业水准”的核心价值观，通过个性化服务方案定制、严格保密协议保障及资深专家团队支持，构建起值得信赖的服务体系。</p>
            <p class="about-us-description">
              在业务实践中，安贝森科服聚焦技术创新与商业模式升级双重维度，提供涵盖知识产权战略布局、科技项目精准申报、商业模式优化创新的一站式解决方案。通过深度诊断企业创新痛点，整合政府、高校及产业资源，助力企业突破技术壁垒，构建核心竞争力。公司已成功服务多家科技企业，通过定制化服务助力其实现快速成长，获得客户高度认可。</p>

            <div class="achievements-container">
              <div class="achievement-item">
                <img src="./zu13.png" alt="Tick Icon" style="width: 20px; height: 20px;">
                <span>国家高新技术企业</span>
              </div>
              <div class="achievement-item">
                <img src="./zu13.png" alt="Tick Icon" style="width: 20px; height: 20px;">
                <span>中国中小企业诚信示范单位</span>
              </div>
              <div class="achievement-item">
                <img src="./zu13.png" alt="Tick Icon" style="width: 20px; height: 20px;">
                <span>中国服务品牌竞争力5强企业</span>
              </div>
              <div class="achievement-item">
                <img src="./zu13.png" alt="Tick Icon" style="width: 20px; height: 20px;">
                <span>湖北省云服务供应商</span>
              </div>
              <div class="achievement-item">
                <img src="./zu13.png" alt="Tick Icon" style="width: 20px; height: 20px;">
                <span>湖北省电子商务示范企业</span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>


    <!--发展历程-->
    <div class="wd100 pdtop" style="width: 1255px; margin: 188px auto;">
      <div class="timeline-header">
        <div class="timeline-header">
          <h2>发展历程 Development history</h2>
        </div>
      </div>
      <div class="timeline-wrapper" style="height:580px">
        <!-- 时间轴线 -->
        <div class="timeline-line"></div>

        <!-- 时间节点 -->
        <div class="timeline-item left item-A">
          <div class="year">2025</div>
          <div class="description">
            <p>2025年湖北省云服务供应商</p>
            <p>2024年国家高新技术企业</p>
            <p>恩施州首张企业数据知识产权登记证书</p>
          </div>
        </div>

        <div class="timeline-item right item-B">
          <div class="year">2024</div>
          <div class="description">
            <p>荆门市中小企业数字化转型城市试点遴选服务商名单</p>
            <p>2024年湖北省工业互联网平台认定企业</p>
            <p>湖北省第四批“两业融合”试点企业</p>
          </div>
        </div>

        <div class="timeline-item left item-C">
          <div class="year">2023</div>
          <div class="description">
            <p>恩施州知识产权保护工作站</p>
            <p>恩施州商标品牌指导站</p>
            <p>恩施州知识产权检索及分析企校联合创新中心</p>
            <p>2023年度中小企业公共服务标杆服务机构</p>
          </div>
        </div>

        <div class="timeline-item right item-D">
          <div class="year">2022</div>
          <div class="description">
            <p>湖北省技术改造咨询诊断服务机构</p>
            <p>湖北省中小企业公共服务平台“专精特新”发展服务合作机构名单</p>
            <p>工业和信息化部中小企业发展促进中心中小企业志愿服务工作站入选机构</p>
          </div>
        </div>

        <div class="timeline-item left item-E">
          <div class="year">2021</div>
          <div class="description">
            <p>湖北省级技术转移示范机构</p>
            <p>国家技术转移中部中心科技成果转化基层站点</p>
            <p>武汉股权托管交易中心挂牌企业</p>
            <p>恩施州技术交易大市场建立及运营机构</p>
          </div>
        </div>

        <div class="timeline-item right item-F">
          <div class="year">2020</div>
          <div class="description">
            <p>年成为湖北省中小企业公共服务严选服务机构</p>
            </div>
        </div>

        <div class="timeline-item left item-G">
          <div class="year">2019</div>
          <div class="description">
            <p>扩充团队，完善各部门专业服务团队</p>
          </div>
        </div>

        <div class="timeline-item right item-H">
          <div class="year">2018</div>
          <div class="description">
            <p> 公司成立，并组建销售团队</p>
          </div>
        </div>
      </div>
    </div>

    <!--企业文化-->
    <div class="wd100 pdtop" style="width: 1255px; margin: 0px auto; height: 800px">
      <div class="timeline-container" style="margin-top: 200px">
        <div class="timeline-header">
          <h2>企业文化 Corporate culture</h2>
        </div>
        <div class="qyContainer">


          <div class="brand-interpretation" alt="我们的使命" v-show="show1">
            <img src="./shiming.png" alt="我们的使命">
            <div style="position: absolute;margin-left: 80px;margin-top: -100px;text-align: center">
              <p style="text-align: center;color: white">我们的使命</p>
              <p style="text-align: center;color: white;font-size: 10px;margin-top: 5px">Our mission</p>
            </div>

            <p style="width: 500px;position: absolute;margin-left: -136px;font-size: 14px;line-height: 2;text-align: center">
              用科技赋能企业，驱动增长与创新。
            </p>
          </div>

          <div class="brand-interpretation" alt="我们的定位" v-show="show2">
            <img src="./dignwei.png" alt="我们的定位">
            <div style="position: absolute;margin-left: 73px;margin-top: -100px;text-align: center">
              <p style="text-align: center;color: white">我们的定位</p>
              <p style="text-align: center;color: white;font-size: 10px;margin-top: 5px">Our positioning</p>
            </div>

            <p style="width: 500px;position: absolute;margin-left: -123px;font-size: 14px;line-height: 2">
              以专业化和优质化服务每一个客户，公司现有各项专业团队和资质，
              财税方面的注册会计，知识产权方面的商标代理人和专利代理人，
              以及自有培养的专业项目申报团队和软件开发团队，做到每一个案件和每一个客户都以专业的建议和用心的服务。
            </p>
          </div>

          <div class="brand-interpretation" alt="核心价值观" v-show="show3">
            <img src="./hexin.png" alt="核心价值观">
            <div style="position: absolute;margin-left: 80px;margin-top: -100px;text-align: center">
              <p style="text-align: center;color: white">核心价值观</p>
              <p style="text-align: center;color: white;font-size: 10px;margin-top: 5px">Core values</p>
            </div>

            <p style="width: 500px;position: absolute;margin-left: -123px;font-size: 14px;line-height: 2">
              1、专业性：追求专业化和优质化服务，做长期、做口碑，提升客户的满意度。<br>
              2、及时性：部分服务项目紧跟国家政策和政府形式，且经常推成出新，需及时准却的研究、判断并及时的和客户反馈、沟通。<br>
              3、团队性：服务过程中可能面临多维度，跨专业的问题需求，需要各部门员工之间的合作，充分发挥各自的专业优势，共同努力维护客户的利益。<br>
              4、诚信：诚信是企业的灵魂。企业必须秉持诚实、守信的原则与客户、供应商等合作伙伴建立良好的信任关系<br>
              5、客户至上：企业的生存和发展离不开客户的支持。企业必须将客户需求放在第一位，为其提供优质的产品和服务，并不断关注客户的反馈和意见。<br>
              6、社会责任:企业不仅要追求经济效益，还要承担社会责任，企业必须关注环境保护、员工合法权益、社会公益等方面，并积极履行自己的社会责任。
            </p>
          </div>

          <div class="brand-interpretation" alt="品牌诠释" v-show="show4">
            <img src="./pingpai.png" alt="品牌诠释">
            <div style="position: absolute;margin-left: 62px;margin-top: -100px;text-align: center">
              <p style="text-align: center;color: white">品牌诠释</p>
              <p style="text-align: center;color: white;font-size: 10px;margin-top: 5px">Brand Interpretation</p>
            </div>

            <p style="width: 500px;position: absolute;margin-left: -123px;font-size: 14px;line-height: 2">
              “安”是平安、安定的意思。它指的首先是国家、社会的安定、稳定，其次是
              个人的安全，平安。“贝”在古代用贝壳做的货币，代表经济和效益。“森”
              代表从一颗树木，壮大到一片树林，发展成整个森林，是一个循序渐进和欣欣
              向荣的发展路程。安贝森科技服务，期望在国家安定祥和的氛围中，为恩施本
              土企业做赋能和服务，自身从一个部门到一个综合团队，从单一服务到全方位
              整体服务的发展规划。对于所服务的企业从成立开始到成长过程中以及壮大发
              展中，同客户企业共同成长共同发展，长期合作、共谋效益。并做到全方位，
              全产业链的一站式服务机构。
            </p>
          </div>


          <div class="values-section">
            <div class="value-item" @mouseover="onMouseOver(1)" @mouseleave="oNmouseleave(1)" >
              <h3 style="color: #0788dc">我们的使命</h3>
            </div>
            <div class="value-item" @mouseover="onMouseOver(2)" @mouseleave="oNmouseleave(1)">
              <h3  style="color: #0788dc">我们的定位</h3>
            </div>
            <div class="value-item" @mouseover="onMouseOver(3)" @mouseleave="oNmouseleave(1)">
              <h3  style="color: #0788dc" >核心价值观</h3>
            </div>
            <div class="value-item" @mouseover="onMouseOver(4)" @mouseleave="oNmouseleave(1)" style="border-left: 2px solid #0788dc;">
              <h3  style="color: #0788dc">品牌诠释</h3>
            </div>
          </div>

        </div>
      </div>
    </div>


    <!--荣誉资质-->

    <div class="wd100 pdtop" style="width: 1255px;margin: 0px auto;">
      <div class="honor-container">
        <div class="honor-header">
          <h2>荣誉资质 Qualification honor</h2>
          <a href="#"  @click="active('/aboutsUsRy')">更多 »</a>
        </div>
      </div>
      <el-carousel :interval="4000" type="card" height="320px" style="text-align: center;margin-top: 130px" arrow="always">
        <el-carousel-item>
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/01.png')" style="height: 260px"></el-image>
          <p class="psty">高新技术企业证书</p>
        </el-carousel-item>

        <el-carousel-item>
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy1.png')"  style="height: 260px"></el-image>
          <p class="psty">恩施州知识产权保护工作站</p>
        </el-carousel-item>

        <el-carousel-item>
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy2.png')" style="height: 260px"></el-image>
          <p class="psty">资产检索分析</p>
        </el-carousel-item>

        <el-carousel-item>
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy3.png')"  style="height: 260px"></el-image>
          <p class="psty">商标品牌指导</p>
        </el-carousel-item>
        <el-carousel-item>
          <el-image class="certificate-imagec" :src="require('../../assets/image/rongyu/yy4.jpg')"  style="height: 260px"></el-image>
          <p class="psty">湖北省严选服务机构</p>
        </el-carousel-item>
      </el-carousel>

    </div>


    <div class="wd100 pdtop" style="width: 1255px;margin: 0px auto;height: 100px">
    </div>
  </div>


</template>
<style scoped>
@import 'aboutsUs.css';
</style>
<script>
import {save} from '@/api/common'

export default {
  components: {},
  data() {
    return {
      srcList: [
        require("../../assets/image/rongyu/01.png"),
        require("../../assets/image/rongyu/yy2.png"),
        require("../../assets/image/rongyu/yy3.png"),
        require("../../assets/image/rongyu/yy4.jpg"),
      ],
      teachers: [],
      show1: false,
      show2: false,
      show3: false,
      show4: true,
    }
  },

  methods: {
    active(url) {
      this.$router.push(url);
    },
    onMouseOver(index){
        this.show1= false
        this.show2= false
        this.show3= false
        this.show4= false

        switch (index) {
          case 1:
            this.show1 = true
            break;
          case 2:
            this.show2 = true
            break;
          case 3:
            this.show3 = true
            break;
          case 4:
            this.show4 = true
            break;
        }
    },
    oNmouseleave(){
      this.show1= false
      this.show2= false
      this.show3= false
      this.show4= true
    }
  },
  mounted: function () {
    document.addEventListener('DOMContentLoaded', () => {
      const years = document.querySelectorAll('.year');
      const summaries = document.querySelectorAll('.wenzhi');

      // 切换年份和文字介绍的函数
      function updateActiveYear(yearElement) {
        // 移除所有年份的 active 类
        years.forEach((year) => year.classList.remove('active'));

        // 隐藏所有文字介绍
        summaries.forEach((summary) => summary.classList.remove('active'));

        // 激活当前年份
        yearElement.classList.add('active');

        // 显示对应的文字介绍
        const selectedYear = yearElement.getAttribute('data-year');
        const activeSummary = document.querySelector(
          `.wenzhi[data-year="${selectedYear}"]`
        );
        if (activeSummary) {
          activeSummary.classList.add('active');
        }
      }

      // 绑定点击事件
      years.forEach((year) => {
        year.addEventListener('click', () => {
          updateActiveYear(year);
        });
      });

      // 自动轮播函数
      let currentYearIndex = 0;

      function autoPlay() {
        currentYearIndex = (currentYearIndex + 1) % years.length;
        updateActiveYear(years[currentYearIndex]);
      }

      // 设置定时器进行自动轮播
      const intervalId = setInterval(autoPlay, 5000); // 轮播间隔时间（5秒）

    });
  },
}
</script>
<style>

.el-carousel__container button{
  background-color: white!important;;
  color: #0788dc;
  border: 2px solid #0788dc;
  font-weight: 500;
  font-size: 16px;
}
.el-carousel__arrow {
  background-color: #0788dc!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/aboutsUs/aboutsUs.vue